import { graphql } from 'react-relay';

export const ContentHeaderUnifiedQuery = graphql`
	query ContentHeaderUnifiedQuery(
		$contentId: ID!
		$spaceKey: String
		$versionOverride: Int
		$embeddedContentRender: String
		$limit: Int
		$useNewContentTopper: Boolean = false
		$status: [String]
		$includeGeneratedBy: Boolean = false
	) {
		content(
			id: $contentId
			version: $versionOverride
			embeddedContentRender: $embeddedContentRender
			status: $status
		) {
			nodes {
				id
				type
				subType
				title
				status
				appearancePublished: properties(key: "content-appearance-published") {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				history {
					createdDate
					createdBy {
						type
						displayName
						... on KnownUser {
							accountId
						}
						profilePicture {
							path
						}
					}
					ownedBy {
						type
						displayName
						... on KnownUser {
							accountId
						}
						profilePicture {
							path
						}
					}
					lastOwnedBy {
						type
						displayName
						... on KnownUser {
							accountId
						}
						profilePicture {
							path
						}
					}
				}
				emojiTitlePublished: properties(key: "emoji-title-published") {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				pageTitlePublished: properties(key: "page-title-property-published")
					@include(if: $useNewContentTopper) {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				properties(key: "editor") {
					nodes {
						id
						key
						value
					}
				}
				space {
					id
					name
					homepageId
				}
				version {
					message
					by {
						type
						displayName
						... on KnownUser {
							accountId
						}
						profilePicture {
							path
						}
					}
					friendlyWhen
					when
					number
					contentTypeModified
				}
				contentProperties @include(if: $includeGeneratedBy) {
					latest {
						generatedBy
					}
				}
				metadata {
					sourceTemplateEntityId
					lastModifiedDate
					frontend {
						fabricEditorSupported
						coverPictureWidth @include(if: $useNewContentTopper)
					}
				}
			}
		}
		contentContributors(id: $contentId, limit: $limit) {
			count
			isCurrentUserContributor
			isOwnerContributor
			nodes {
				type
				displayName
				... on KnownUser {
					accountId
				}
				profilePicture {
					path
				}
			}
		}
		space(key: $spaceKey) {
			id
			theme {
				themeKey
			}
			lookAndFeel {
				headings {
					key
					value
				}
				content {
					header {
						background
						backgroundAttachment
						backgroundBlendMode
						backgroundClip
						backgroundColor
						backgroundImage
						backgroundOrigin
						backgroundPosition
						backgroundRepeat
						backgroundSize
						borderRadius
						padding
					}
				}
			}
		}
	}
`;
